import { $admin } from "@/utils/https.js";
//添加到购物车
export function addToCart(data) {
    return $admin().post(`/api/admin/manage/mall/cart`, data);
}

//获取购物车列表
export function getCart(params) {
    return $admin().get(`/api/admin/manage/mall/cart`, { params });
}

//删除购物车
export function deleteCart(id) {
    return $admin().delete(`/api/admin/manage/mall/cart/${id}`);
}

//批量删除购物车
export function batchDeleteCart(data) {
    return $admin().delete(`/api/admin/manage/mall/cart`, { data });
}
//更新购物车
export function updateCartItem(id, data) {
    return $admin().put(`/api/admin/manage/mall/cart/${id}`, data);
}

//创建内部订单
export function createOrder(data) {
    return $admin().post(`/api/admin/manage/mall/internal/order`, data);
}
// 支付订单备注
export function pay(order_no, data) {
    return $admin().post(`/api/admin/manage/mall/internal/order/${order_no}/pay`, data);
}

// 检查支付订单
export function checkPay(pay_order_no) {
    return $admin().get(`/api/admin/mall/internal/order/pay_check`, {
        params: {
            pay_order_no,
        },
    });
}

// 获取订单详情
export function getOrderInfo(order_no) {
    return $admin().get(`/api/admin/manage/mall/internal/order/${order_no}`);
}

// 获取订单列表
export function getOrderList(params) {
    return $admin().get(`/api/admin/manage/mall/internal/order`, { params });
}

// 取消订单
export function cancelOrder(order_no) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${order_no}/cancel`);
}
// 关闭订单
export function closeOrder(id) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/close`);
}
//更新内部订单
export function updateOrder(id, data) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}`, data);
}

//改价
export function updateOrderPrice(id, data) {
    const payload = {
        price: data.price || 0,
        remark: data.remark || "",
    };
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/discount`, payload);
}
//删除订单
export function deleteOrder(order_no) {
    return $admin().delete(`/api/admin/manage/mall/internal/order/${order_no}`);
}

//更新管理员备注
export function updateAdminRemark(id, remark) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/remark`, {
        remark: remark,
    });
}
//获取订单统计
export function getOrderStat(params) {
    return $admin().get(`/api/admin/manage/mall/internal/order/stat`, { params });
}

//查询内部订单日志
export function getOrderLog(id) {
    return $admin().get(`/api/admin/manage/mall/internal/order/${id}/log`);
}
//更新内部订单日志
export function updateOrderLog(id, data) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/log`, data);
}

//更新发货信息
export function updateDeliveryInfo(id, data) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/send`, data);
}

//添加管理员备注
export function addAdminRemark(id, remark) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/remark`, {
        remark: remark,
    });
}

//批量加入购物车
export function batchAddToCart(data) {
    return $admin().post(`/api/admin/manage/mall/cart/bulk`, data);
}
//关联意向订单
export function linkIntentionOrder(id, data) {
    return $admin().put(`/api/admin/manage/mall/internal/order/${id}/relate`, data);
}

//生成欧陆小程序二维码
export function generateMiniQrcode(data) {
    return $admin().post(`/api/erp/manage/wechat/miniprogram/eurofins/qrcode`, data, {
        responseType: "arraybuffer",
    });
}
//生成titan小程序二维码
export function generateTitanMiniQrcode(data) {
    return $admin().post(`/api/erp/manage/wechat/miniprogram/titan/qrcode`, data, {
        responseType: "arraybuffer",
    });
}

//取消关联意向订单
export function cancelLinkIntentionOrder(id, params) {
    return $admin().delete(`/api/admin/manage/mall/internal/order/${id}/relate`, { params });
}
